import { __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/helpers/index.ts
var noop = () => {};
var getMatches = queryMatch => {
  if (typeof window === "undefined") return void 0;
  return window.matchMedia(queryMatch).matches;
};
function isSmoothScrollAllowed() {
  return getMatches("(prefers-reduced-motion: no-preference)") === true;
}
var scrollTo = (element, scrollToOptions) => {
  element.scrollTo(__spreadProps(__spreadValues({}, scrollToOptions), {
    behavior: isSmoothScrollAllowed() === true && (scrollToOptions == null ? void 0 : scrollToOptions.behavior) === "smooth" ? "smooth" : "auto"
  }));
};
var scrollIntoView = (element, scrollIntoViewOptions) => {
  element.scrollIntoView(__spreadProps(__spreadValues({}, scrollIntoViewOptions), {
    behavior: isSmoothScrollAllowed() && (scrollIntoViewOptions == null ? void 0 : scrollIntoViewOptions.behavior) === "smooth" ? "smooth" : "auto"
  }));
};
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}
export { noop, getMatches, isSmoothScrollAllowed, scrollTo, scrollIntoView, clamp };